(function () {
  const sectionInstances = new WeakMap();

  class RecentlyViewedSlider {
    constructor(layoutEl) {
      this.layoutEl = layoutEl;
      this.wrapper = layoutEl.querySelector(".popular-products__wrapper");
      this.perRow = Number(layoutEl.dataset.cardsPerRow || 1);
      this.breakpointMap = this.buildBreakpointMap();
      this.swiper = null;
      this.resizeObserver = null;
    }

    buildBreakpointMap() {
      const steps = [
        { bp: 0, cols: 1 },
        { bp: 750, cols: 2 },
        { bp: 1200, cols: 3 },
        { bp: 1536, cols: 4 },
      ];

      return steps.filter((step) => step.cols <= this.perRow);
    }

    getCurrentCols() {
      const viewportWidth = window.innerWidth;
      let cols = 1;

      this.breakpointMap.forEach((step) => {
        if (viewportWidth >= step.bp) {
          cols = step.cols;
        }
      });

      return cols;
    }

    updateOverflow() {
      const visibleSlides =
        this.wrapper.querySelectorAll(".popular-products__card").length;
      const currentCols = this.getCurrentCols();

      this.layoutEl.classList.toggle(
        "has-overflow",
        visibleSlides > currentCols
      );
    }

    init() {
      if (!this.wrapper || !this.wrapper.children.length) {
        this.layoutEl.classList.remove("has-overflow");
        return;
      }

      // Mobile centers the intermediate slides, first/last stay flush to the edges.
      // Must be switched off explicitly at 750 — breakpoint params merge, they don't reset.
      this.swiper = new Swiper(this.layoutEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        speed: 1000,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            spaceBetween: 24,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
        on: {
          init: () => {
            this.updateOverflow();
          },
          resize: () => {
            this.updateOverflow();
          },
        },
      });

      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.swiper) return;
          this.swiper.update();
          this.updateOverflow();
        });
        this.resizeObserver.observe(this.layoutEl);
      }
    }

    destroy() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
    }
  }

  const initSectionLayout = (section) => {
    const box = section.querySelector(".recently-viewed");
    if (!box) return;

    const existing = sectionInstances.get(section);
    if (existing) {
      existing.destroy();
      sectionInstances.delete(section);
    }

    const layout = box.dataset.layout || "grid";
    if (layout !== "slider") return;

    const layoutEl = section.querySelector(".js-recently-viewed-slider");
    if (!layoutEl) return;

    const slider = new RecentlyViewedSlider(layoutEl);
    slider.init();
    sectionInstances.set(section, slider);
  };

  const initSection = async (section) => {
    if (!section || !section?.classList.contains("recently-viewed-section")) {
      return;
    }

    const box = section.querySelector(".recently-viewed");
    if (!box) return;

    const STORAGE_KEY = "__theme__recently_products";
    const EXPIRATION_DAYS = box.dataset.expirationDays
      ? Number(box.dataset.expirationDays)
      : 30;
    const dateNow = Date.now();

    const baseUrl = box.dataset.baseUrl;
    const productsLimit = Number(box.dataset.productsLimit) || 6;
    const currentPageProductId = box.dataset.currentPageProductId;

    // get recent products from local storage
    let recentProducts = [];
    try {
      recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      console.error(`Incorrect value in local storage for "${STORAGE_KEY}"`);
    }

    if (currentPageProductId) {
      recentProducts = recentProducts.filter(
        (item) => item.productId !== currentPageProductId
      );
    }

    if (recentProducts.length === 0) {
      box.classList.remove("recently-viewed--loading");
      box.classList.add("recently-viewed--empty");
      return;
    }

    // filter by expiration time
    const expirationTime = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    const validProducts = recentProducts.filter(
      (item) => dateNow - item.timestamp < expirationTime
    );

    // limit by section setting
    const limitedProducts = validProducts.slice(0, productsLimit);

    // get url with query
    const query = limitedProducts
      .filter((item) => item.productId)
      .map((item) => `id:${item.productId}`)
      .join("%20OR%20");
    const url = `${baseUrl}&q=${query}`;

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const sourceBox = doc?.querySelector(".recently-viewed");
      if (!sourceBox?.classList.contains("recently-viewed--search-perfomed")) {
        box.classList.add("recently-viewed--empty");
        return;
      }
      box.innerHTML = sourceBox.innerHTML;

      initSectionLayout(section);
    } catch (error) {
      console.error("Failed to fetch recently viewed products:", error);
      box.classList.add("recently-viewed--empty");
    } finally {
      box.classList.remove("recently-viewed--loading");
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
